import { Box, Typography } from "@mui/material";
import React from "react";
interface InputProps {
    fieldName: any;
}
const NonCompulsoryFieldsLabel: React.FC<InputProps> = ({ fieldName }) => {
    return (
        <Box display="flex">
            <Typography gutterBottom fontFamily="Gilroy-Regular" fontSize="14px" ml="4px">
                {fieldName}
            </Typography>
            {/* <Typography gutterBottom fontFamily="Gilroy-Regular" fontSize="14px" ml="4px" color="#FF0000">
                *
            </Typography> */}
        </Box>
    );
};

export default NonCompulsoryFieldsLabel;
